import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-delete-modal',
  templateUrl: './delete-modal.component.html',
  styleUrls: ['./delete-modal.component.scss']
})
export class DeleteModalComponent implements OnInit {
  @Input() modelId : any;
  @Input() modalName :any;
  @Input() loading :any;
  @Input() title :any;
  @Output() deleteItem = new EventEmitter();
  
  constructor(
    private spinner: NgxSpinnerService,
  ) { }

  ngOnInit(): void {
    this.spinner.show()
  
  }

 
  onDelete(){
    this.deleteItem.emit()
  }

}
